let orientations = {
    landscape: 'landscape',
    portrait: 'portrait'
};

export default {
    data() {
        return {
            deviceOrientation: null,
            touchEnabled: null
        }
    },
    methods: {
        getDeviceOrientation() {
            return window.innerHeight > window.innerWidth
                ? orientations.portrait
                : orientations.landscape
            ;
        },
        hasTouchscreen() {
            return 'ontouchstart' in document.documentElement;
        },
        detectDeviceFeatures() {
            this.deviceOrientation = this.getDeviceOrientation();
            this.touchEnabled = this.hasTouchscreen();
        },
        initDeviceDetection() {
            this.detectDeviceFeatures();
            window.addEventListener(
                'resize',
                this.detectDeviceFeatures
            );
        }
    }
};